import React from 'react'
import PropTypes from 'prop-types'

import ScrollToTop from '../ScrollToTop/ScrollToTop'
import { PageHeader } from '../PageHeader/PageHeader'
import CloseButton from '../CloseButton/CloseButton'

import Link from '../Link/Link'

import './AccountHeader.css'

const AccountHeader = ({ to, title }) => {
  return (
    <div styleName='account-header'>
      <ScrollToTop />
      <PageHeader header={title} />
      <div styleName='close-button-wrapper'>
        <CloseButton data-testid='close-button-account-page' to={to} />
      </div>
      <div styleName='close-link'>
        <Link to={to} data-testid='link-back-to-menu' style='primary'>
          Back to Menu
        </Link>
      </div>
    </div>
  )
}

AccountHeader.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default AccountHeader
